var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useCallback } from 'react';
export var DragSource = createOverridableComponent('div', function (_a, Component, ref) {
    var _b = _a.dropEffect, dropEffect = _b === void 0 ? 'move' : _b, dragData = _a.dragData, onDragStart = _a.onDragStart, props = __rest(_a, ["dropEffect", "dragData", "onDragStart"]);
    var _onDragStart = useCallback(function (e) {
        e.dataTransfer.dropEffect = dropEffect;
        if (dragData) {
            for (var k in dragData) {
                e.dataTransfer.setData(k, dragData[k]);
            }
        }
        if (onDragStart) {
            onDragStart(e);
        }
    }, [dragData, dropEffect, onDragStart]);
    return (jsx(Component, __assign({ ref: ref }, props, { onDragStart: _onDragStart, draggable: true, sx: { cursor: 'grab' } })));
});
//# sourceMappingURL=DragSource.js.map